// Cross-page Amplitude events used to compare Home with the legacy homepages
// (see docs/project/HomeAnalyticsEvents.md). Properties are ids and enums only.

export const HOMEPAGE_ANALYTICS = {
  changed: 'HOMEPAGE_CHANGED',
  candidateViewed: 'HOMEPAGE_CANDIDATE_VIEWED',
  switchFeedback: 'HOMEPAGE_SWITCH_FEEDBACK'
} as const;

// Pages the Home title switcher offers, in homepage key names.
export type THomepageSwitchTarget = 'meetings' | 'calls';

export type THomepageSwitchReason =
  | 'prefers_list'
  | 'missing_content'
  | 'other';

export type THomepageSwitchOutcome =
  | 'switched'
  | 'kept_home'
  | 'dismissed'
  | 'tip_clicked';

// The one Home event that carries free text: the optional note is the
// feedback the prompt asks for. Capped at HOMEPAGE_SWITCH_NOTE_MAX_LENGTH.
export interface IHomepageSwitchFeedbackProperties {
  to: THomepageSwitchTarget;
  reason: THomepageSwitchReason | null;
  outcome: THomepageSwitchOutcome;
  note?: string;
}

export const HOMEPAGE_SWITCH_NOTE_MAX_LENGTH = 500;

export const MEETING_OPENED_EVENT = 'MEETING_OPENED';

export type TMeetingOpenedSurface =
  | 'home_widget'
  | 'meetings_list'
  | 'calls_dashboard'
  | 'global_search';

export type TMeetingOpenedTarget =
  | 'detail_page'
  | 'quick_view'
  | 'play'
  | 'snippet';

export interface IMeetingOpenedProperties {
  surface: TMeetingOpenedSurface;
  target: TMeetingOpenedTarget;
}
